import { Api } from "../config/request";

export default {
  getDriverAssetIssuance(queryParams) {
    return Api.get(`/driver-assets/issuance/tracking${queryParams}`);
  },
};
